// extracted by mini-css-extract-plugin
export default {"container":"ZlCTd","header":"_3ItOg","menu":"_2fK2b"};